import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const usePreserveScroll = () => {
  const location = useLocation();

  useEffect(() => {
    // Restore scroll position if coming back
    const savedScrollY = sessionStorage.getItem("scrollPosition");
    if (savedScrollY) {
      window.scrollTo({ top: parseInt(savedScrollY, 10), behavior: "smooth" });
    }

    const handleScroll = () => {
      sessionStorage.setItem("scrollPosition", window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname]);

  return null;
};

export default usePreserveScroll;
